<template>
  <div class="row m-0 justify-content-center pt-20 pb-20">
    <div class="col-8">
      <div class="d-flex align-items-center justify-content-center">
        <b-col md="12" cols="12">
          <b-form
            class="auth-login-form mt-2 p-4 text-center"
            @submit.prevent="signUp"
          >
            <b-row>
              <b-col md="6" cols="12">
                <b-form-input
                  v-model="RegisterData.name"
                  name="name"
                  type="text"
                  placeholder="إسم المستخدم"
                />
              </b-col>
              <b-col md="6" cols="12">
                <b-form-input
                  v-model="RegisterData.email"
                  name="email"
                  type="text"
                  placeholder=" ...البريد الإلكتروني"
                />
              </b-col>
              <b-col md="6" cols="12">
                <b-form-input
                  v-model="RegisterData.password"
                  name="password"
                  type="password"
                  placeholder="كلمة المرور"
                />
              </b-col>
              <b-col md="6" cols="12">
                <b-form-input
                  v-model="RegisterData.password_confirmation"
                  name="password_confirmation"
                  type="password"
                  placeholder=" تأكيد كلمة المرور"
                />
              </b-col>
            </b-row>
            <!-- submit button -->
            <b-button
              class="login-btn"
              v-if="!loader"
              variant="primary"
              type="submit"
              block
            >
              <span>إنشاء حساب</span>
            </b-button>
            <b-button
              class="login-btn"
              v-if="loader"
              variant="primary"
              disabled
              block
            >
              <b-spinner small type="grow" />
              برجاء الانتظار...
            </b-button>
          </b-form>
          <div v-if="RegisterError" class="text-danger mt-2">
            {{ RegisterError }}
          </div>
        </b-col>
      </div>
    </div>
  </div>
</template>

  <script>
import axios from "axios";

export default {
  name: "RegisterPage",
  components: {},
  data() {
    return {
      status: "",
      loader: false,
      RegisterData: {
        password: "",
        email: "",
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {},
  methods: {
    async signUp() {
      this.loader = true;

      try {
        await axios
          .post("companies/register", this.RegisterData)
          .then((response) => {
            if (response.status === 200) {
              this.$toast.success("تم التسجيل بنجاح ", {
                duration: 5000,
                position: "bottom-left",
              });
            }
            this.$emit("registration-successful"); // Emit the event

          })
          .finally(() => {
            this.loader = false;
          });
      } catch (e) {
        if (e) {
          this.$toast.error(e.response.data.message, {
                duration: 5000,
                position: "bottom-left",
              });        }
      }
    },
  },
};
</script>
